import { render, staticRenderFns } from "./SFXAddAssetBundle.vue?vue&type=template&id=65700235&"
import script from "./SFXAddAssetBundle.vue?vue&type=script&lang=js&"
export * from "./SFXAddAssetBundle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports